<template>
  <RevCard class="p-32">
    <h2 class="text-static-default-hi heading-3 mb-24 md:heading-2">
      {{ i18n(translations.title) }}
    </h2>
    <p class="text-static-default-low body-1 mb-32 max-w-1376 text-balance">
      {{ i18n(translations.description) }}
    </p>
    <RevButton
      :to="{ name: ROUTE_NAMES.OPTIONS.ADDRESSES }"
      variant="secondary"
    >
      {{ i18n(translations.cta) }}
    </RevButton>
  </RevCard>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Addresses.translations'

const i18n = useI18n()
</script>
